
export const CONTENTS_LISTS_ROUTES = {
    CONTENTS: "/contents",
    CATEGORIES: "/categories",
    TAGS: "/tags",
};
